<template>
    <div id="edit-template" :class="planCategory">
        <b-row class="justify-content-md-center">
            <b-col md="8" xl="6">
                <h2 class="create-plans-header">See Plan</h2>
                <b-card header="See Template">
                    <b-form-group>
                        <label for="pname">Plan Name</label>
                        <b-form-input
                            type="text"
                            id="pname"
                            placeholder="Enter your plan name"
                            v-model="tempTemplate.name"
                            disabled
                        ></b-form-input>
                    </b-form-group>
                </b-card>
                <pre style="display: none;"></pre>
                <b-card header="Plan Selection">
                    <div class="wrapper-plan">
                        <div
                            class="plan plan-flex"
                            data-plan-category="Flex"
                            :class="{'active': tempTemplate.category == 'Flex'}"
                        >
                            <div class="innerplan">
                                <span class="selected">Selected</span>

                                <span class="name-plan">My plan</span>
                                <h3>Flex</h3>
                                <span class="desc">Simple flexible IoT data</span>

                                <b-button
                                    data-plan="flex"
                                    variant="success"
                                >Select</b-button>
                            </div>
                        </div>

                        <div
                            class="plan plan-high"
                            data-plan-category="High Bandwidth"
                            :class="{'active': tempTemplate.category == 'High Bandwidth'}"
                        >
                            <div class="innerplan">
                                <span class="selected">Selected</span>

                                <span class="name-plan">My plan</span>
                                <h3>High Bandwidth</h3>
                                <span class="desc">Recommended for: Domestic Usage 1GB+</span>

                                <b-button
                                    data-plan="high-bandwidth"
                                    variant="success"
                                >Select</b-button>
                            </div>
                        </div>
                    </div>
                </b-card>
                <b-card header="Description">
                    <b-form-group>
                        <b-form-input
                            type="text"
                            id="pdesc"
                            v-model="tempTemplate.description"
                            disabled
                            placeholder="Describe the plan you are creating to fit it's usage best"
                        ></b-form-input>
                    </b-form-group>
                </b-card>

                <b-card header="Data Limit">
                    <div class="wrapper-switches data-limit">
                        <button class="button-data flex-data" :class="{'active': tempTemplate.dataLimit == '1MB'}" data-limit="1MB" v-on:click="changeDataLimit">1mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '2MB'}"
                            data-limit="2MB"
                        >2mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '3MB'}"
                            data-limit="3MB"
                        >3mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '5MB'}"
                            data-limit="5MB"
                        >5mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '10MB'}"
                            data-limit="10MB"
                        >10mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '25MB'}"
                            data-limit="25MB"
                        >25mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '50MB'}"
                            data-limit="50MB"
                        >50mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '75MB'}"
                            data-limit="75MB"
                        >75mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '100MB'}"
                            data-limit="100MB"
                        >100mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '250MB'}"
                            data-limit="250MB"
                        >250mb</button>
                        <button
                            class="button-data flex-data"
                            :class="{'active': tempTemplate.dataLimit == '500MB'}"
                            data-limit="500MB"
                        >500mb</button>
                        <button
                            class="button-data flex-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '1GB'}"
                            data-limit="1GB"
                        >1gb</button>
                        <button
                            class="button-data flex-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '2GB'}"
                            data-limit="2GB"
                        >2gb</button>
                        <button
                            class="button-data flex-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '5GB'}"
                            data-limit="5GB"
                        >5gb</button>
                        <button
                            class="button-data flex-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '10GB'}"
                            data-limit="10GB"
                        >10gb</button>
                        <button
                            class="button-data flex-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '20GB'}"
                            data-limit="20GB"
                        >20gb</button>
                        <button
                            class="button-data hb-data"
                            :class="{'active': tempTemplate.dataLimit == '50GB'}"
                            data-limit="50GB"
                        >50gb</button>
                    </div>
                </b-card>

                <b-card header="Options">
                    <b-row>
                        <b-col md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="success" variant="3d" label v-bind="labelIcon" v-model="tempTemplate.options.roaming.status" disabled/>
                            <label>Tier 1 International Roaming</label>
                        </b-col>

                        <b-col md="6" class="switch-label flex-data">
                            <c-switch class="mx-1" color="success" variant="3d" label v-bind="labelIcon" v-model="tempTemplate.options.roaming2.status" disabled/>
                            <label>Tier 2 International Roaming</label>
                        </b-col>
                        <b-col md="6" class="switch-label">
                            <c-switch
                                class="mx-1"
                                color="success"
                                variant="3d"
                                label
                                v-bind="labelIcon"
                                v-model="tempTemplate.options.pooling.status"
                                disabled
                            />
                            <label>Data Pooling</label>
                        </b-col>
                        <b-col md="6" class="switch-label">
                            <c-switch
                                class="mx-1"
                                color="success"
                                variant="3d"
                                label
                                v-bind="labelIcon"
                                v-model="tempTemplate.options.sms.status"
                                disabled
                            />
                            <label>SMS</label>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card header="Data Guard" class="data-guard">
                    <b-row>
                        <b-col md="6">
                            <div class="data-innerbox">
                                <div class="header">
                                    <h3>Throttle</h3>

                                    <c-switch
                                        class="mx-1"
                                        color="success"
                                        variant="3d"
                                        label
                                        v-bind="labelIcon"
                                        v-model="tempTemplate.dataGuard.throttle.status"
                                        disabled
                                    />
                                </div>

                                <div class="inner">
                                    <div class="row-throttle">
                                        <span class="label">Throttle</span>
                                        <div class="value">
                                            <b-form-input disabled
                                                type="text"
                                                id="throttle-mb"
                                                v-model="tempTemplate.dataGuard.throttle.value"
                                            ></b-form-input>
                                            <b-form-select disabled
                                                :options="dataThrottle"
                                                v-model="tempTemplate.dataGuard.throttle.unit"
                                            ></b-form-select>
                                        </div>
                                    </div>

                                    <div class="row-speed">
                                        <span class="label">Speed</span>
                                        <div class="value">
                                            <select disabled class="form-control custom-select" name="throttleSpeed" id="speed-kbs">
                                                <option v-for="(item, index) in speedGuard" v-bind:key="index" :selected="item.value == tempTemplate.dataGuard.speed.id">{{item.text}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>

                        <b-col md="6">
                            <div class="data-innerbox">
                                <div class="header">
                                    <h3>Cap</h3>

                                    <c-switch
                                        class="mx-1"
                                        color="success"
                                        variant="3d"
                                        label
                                        v-bind="labelIcon"
                                        v-model="tempTemplate.dataGuard.cap.status"
                                        disabled
                                    />
                                </div>

                                <div class="inner">
                                    <div class="row-throttle">
                                        <span class="label">Cap</span>
                                        <div class="value">
                                            <b-form-input
                                                type="text"
                                                id="cap-mb"
                                                v-model="tempTemplate.dataGuard.cap.value"
                                                disabled
                                            ></b-form-input>
                                            <b-form-select
                                                :options="dataThrottle"
                                                v-model="tempTemplate.dataGuard.cap.unit"
                                                disabled
                                            ></b-form-select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>

                <b-card class="button-wrap text-center">
                    <router-link to="/settings/plans/">
                        <b-button variant="light">Cancel</b-button>
                    </router-link>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import Vue from "vue";
import Axios from "axios";
import globalStore from "../../variables";
import { template } from "@babel/core";
import Router from "vue-router";
import Vuex from "vuex";
import { Switch as cSwitch } from "@coreui/vue";
import { log } from "util";

Vue.use(Router);

export default {
    name: "EditPlan",
    components: {
        cSwitch
    },
    data() {
        return {
            speedGuard: [
                { value: 1, text: '64 Kbps' },
                { value: 2, text: '128 Kbps' },
                { value: 3, text: '256 Kbps' },
                { value: 4, text: '512 Kbps' },
                { value: 5, text: '768 Kbps' },
                { value: 6, text: '1 Mbps' },
                { value: 7, text: '25 Mbps' }
            ],
            planId: "",
            typePlan: "",
            dataTemplate: {},
            planCategory: "",
            tempTemplate: {
                id: null,
                name: null,
                description: null,
                category: null,
                dataLimit: null,
                options: {
                    pooling: {
                        status: false
                    },
                    sms: {
                        status: false
                    },
                    roaming: {
                        status: false
                    },
                    roaming2: {
                        status: false
                    }
                },
                dataGuard: {
                    throttle: {
                        status: false,
                        value: null,
                        unit: null
                    },
                    speed: {
                        id: null,
                    },
                    cap: {
                        status: false,
                        value: null,
                        unit: null
                    }
                }
            },
            items: [
                {
                    size: "Large",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "lg",
                        checked: true
                    },
                    size_prop: 'Add following prop <code>size="lg"</code>'
                },
                {
                    size: "Normal",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "",
                        checked: true
                    },
                    size_prop: "-"
                },
                {
                    size: "Small",
                    example: {
                        variant: "3d",
                        color: "primary",
                        size: "sm",
                        checked: true
                    },
                    size_prop: 'Add following prop <code>size="sm"</code>'
                }
            ],
            checker: "yes",
            picker: "",
            labelIcon: {
                dataOn: "\u2713",
                dataOff: "\u2715"
            },
            labelTxt: {
                dataOn: "yes",
                dataOff: "no"
            },
            speedThrottle: ["MB/s", "GB/s"],
            dataThrottle: ["mb", "gb"],
        };
    },
    methods: {
        toggleActive(event) {
            event.preventDefault();
            event.stopPropagation();

            let elem = event.target;
        },
        selectPlan(event) {
            event.preventDefault();
            event.stopPropagation();

            let buttonSelected = event.target,
                selectedPlan = event.target.dataset.plan,
                wrapperPlanSelected = buttonSelected.closest("div.plan");

            document.querySelector("#edit-template").className = selectedPlan;

            document
                .querySelector(".wrapper-plan .plan.active")
                .classList.remove("active");

            this.tempTemplate.category =
                wrapperPlanSelected["attributes"]["data-plan-category"][
                    "value"
                ];
            wrapperPlanSelected.classList.add("active");
        },
        changeDataLimit(event) {
            event.preventDefault();
            event.stopPropagation();

            var buttonLimit = event.target["attributes"]["data-limit"]["value"];
            this.tempTemplate.dataLimit = buttonLimit;
        }
    },
    mounted() {
        Axios.get(
            globalStore.data.restApiUrl +
                "/account/rate-plans/" +
                this.$route.params.id
        ).then(response => {
            this.dataTemplate = response.data.response[0];

            this.planCategory = this.dataTemplate.planCategory.planCategoryName;
            this.planCategory = this.planCategory.toLowerCase();
            this.planCategory = this.planCategory.replace(" ", "-");

            this.tempTemplate.id = this.dataTemplate.templateId;
            this.tempTemplate.name = this.dataTemplate.planName;
            this.tempTemplate.description = this.dataTemplate.planDescription;
            this.tempTemplate.category = this.dataTemplate.planCategory.planCategoryName;
            this.tempTemplate.dataLimit = this.dataTemplate.dataLimit.dataLimitName;

            if (this.dataTemplate.planOptions) {
                var templateOptions = this.dataTemplate.planOptions;

                for (var i = 0; i < templateOptions.length; i++) {
                    if(templateOptions[i]['planOptionName'] == "Tier 1 International Roaming") {
                        this.tempTemplate.options.roaming.status = true;
                    }

                    if(templateOptions[i]['planOptionName'] == "Tier 2 International Roaming") {
                        this.tempTemplate.options.roaming2.status = true;
                    }

                    if (templateOptions[i]["planOptionName"] == "Data Pooling") {
                        this.tempTemplate.options.pooling.status = true;
                    }

                    if (templateOptions[i]["planOptionName"] == "SMS") {
                        this.tempTemplate.options.sms.status = true;
                    }
                }
            }

            if (this.dataTemplate.dataGuard) {
                if (this.dataTemplate.dataGuard.hasThrottle > 0) {
                    this.tempTemplate.dataGuard.throttle.status = true
                }
                if (this.dataTemplate.dataGuard.throttleAt && this.dataTemplate.dataGuard.throttleAt != 0) {
                    this.tempTemplate.dataGuard.throttle.value = this.dataTemplate.dataGuard.throttleAt
                }
                if (this.dataTemplate.dataGuard.throttleAtUnit && this.dataTemplate.dataGuard.throttleAtUnit != '') {
                    this.tempTemplate.dataGuard.throttle.unit = this.dataTemplate.dataGuard.throttleAtUnit
                }
                if (this.dataTemplate.dataGuard.throttleSpeed && this.dataTemplate.dataGuard.throttleSpeed.throttleSpeedId) {
                    this.tempTemplate.dataGuard.speed.id = this.dataTemplate.dataGuard.throttleSpeed.throttleSpeedId
                }
                if (this.dataTemplate.dataGuard.hasCap > 0) {
                    this.tempTemplate.dataGuard.cap.status = true
                }
                if (this.dataTemplate.dataGuard.capAt && this.dataTemplate.dataGuard.capAt != 0) {
                    this.tempTemplate.dataGuard.cap.value = this.dataTemplate.dataGuard.capAt
                }
                if (this.dataTemplate.dataGuard.capAtUnit && this.dataTemplate.dataGuard.capAtUnit != '') {
                    this.tempTemplate.dataGuard.cap.unit = this.dataTemplate.dataGuard.capAtUnit
                }
            }
        });
    }
};
</script>

<style lang="scss" scoped>
.flex {
    .hb-data {
        display: none;
        &.flex-data {
            display: inline-block;
        }
    }
}

.high-bandwidth {
    .flex-data {
        display: none;
        &.hb-data {
            display: inline-block;
        }
    }
}

.select-plan {
    .card-header {
        margin-bottom: 20px;
        display: flex;
        justify-content: space-between;
        div {
            line-height: 35px;
        }
        i {
            width: 18px;
            height: 18px;
            -webkit-border-radius: 100%;
            -moz-border-radius: 100%;
            border-radius: 100%;
            border: 2px solid #000000;
            line-height: 13px;
            &::before {
                font-size: 11px;
                line-height: 13px;
            }
        }
    }
}

.data-limit {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-wrap: wrap;
    .button-data {
        width: 10%;
        height: 45px;
        line-height: 40px;
        margin-right: 1%;
        margin-bottom: 1%;
        background-color: transparent;
        border: 1px solid #c9cfd4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;
        font-size: 14px;
        text-transform: uppercase;
        outline: none;

        &.active {
            background-color: #55cd6c !important;
            border-color: #cff3d6 !important;
            color: #fff;
        }
        &:hover {
            cursor: not-allowed;
        }
    }
}

.switch-label {
    margin-bottom: 20px;
    label {
        vertical-align: middle;
        margin: 0;
        + label {
            margin-left: 10px;
        }
    }
}

.wrapper-plan {
    display: flex;
    justify-content: space-between;

    .plan {
        position: relative;
        padding: 20px 0;
        width: 48%;

        border: 1px solid #c9cfd4;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
        border-radius: 5px;

        text-align: center;

        -webkit-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        -moz-box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
        box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

        &.active {
            border: 1px solid #55cd6c;
            -webkit-box-shadow: 0 0 0 2px #55cd6c;
            -moz-box-shadow: 0 0 0 2px #55cd6c;
            box-shadow: 0 0 0 2px #55cd6c;

            .selected {
                display: block;
            }
        }

        &.plan-flex {
            h3 {
                color: #55cd6c;
            }
        }

        &.plan-high {
            h3 {
                color: #FF5ADE;
            }
        }

        .selected {
            display: none;
            position: absolute;
            right: 0;
            top: 0;
            height: 29px;
            line-height: 29px;
            padding: 0 20px;

            background-color: #55cd6c;

            font-size: 14px;
            font-weight: 700;
            line-height: 29px;
            color: #fff;
        }

        .name-plan {
            display: block;
            margin-bottom: 20px;

            font-size: 14px;
            text-transform: uppercase;
        }

        h3 {
            font-size: 28px;
            line-height: 37px;
            font-weight: 700;
            text-transform: uppercase;
        }

        .desc {
            display: block;
            margin-bottom: 20px;

            text-align: center;
        }

        button {
            cursor: not-allowed;
            pointer-events: none;
        }
    }
}

.data-guard {
    .data-innerbox {
        .header {
            margin-bottom: 10px;
            h3 {
                display: inline-block;
                vertical-align: top;
                margin: 0;
                margin-top: 4px;

                font-size: 15px;
                font-weight: 700;
            }

            label {
                float: right;
            }
        }
        .row-throttle,
        .row-speed {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            margin-bottom: 20px;

            .value {
            }

            .label {
                width: 100%;
                display: block;
            }
        }
    }
}

.button-wrap .card-body {
    justify-content: center;
}

.row-throttle,
.row-speed {
    flex-direction: column;
    width: 100%;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    margin: 0 !important;
    .label {
        display: block;
        margin-bottom: 6px;
    }
    .value {
        width: 100%;
        max-width: 250px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        input {
            width: 79%;
        }

        select {
            width: 30%;
            margin-left: 10px;
            min-width: 80px;
            text-transform: uppercase;
            &#speed-kbs {
                width: 100%;
                margin: 0;
            }
        }
    }
}

.switch-label {
    //margin-bottom: 20px;
    label {
        vertical-align: middle;
        margin: 0;
        + label {
            margin-left: 10px;
        }
    }
    .mx-1 {
        float: right;
    }
}
</style>
